<mat-toolbar class="matero-toolbar">
  <app-branding *ngIf="showBranding"></app-branding>
  <app-topmenu></app-topmenu>
  <span fxFlex></span>
  <button color="primary" mat-mini-fab (click)="toggleFullscreen()">
    <mat-icon *ngIf="!isFullScreen">fullscreen</mat-icon>
    <mat-icon *ngIf="isFullScreen">close_fullscreen</mat-icon>
  </button>
  <app-user></app-user>
</mat-toolbar>
